import {Theme, SxProps} from '@mui/material'

const BUTTON_BORDER_COLOR = 'var(--border_highlight_10)'

// Match the Shift Events tab group on light surfaces; preserve the existing theme border otherwise.
export const getButtonOutlineWhite = (theme: Theme) => ({
  border: 1,
  borderColor: BUTTON_BORDER_COLOR,
  color: theme.palette.text.primary,
  padding: 2,
  backgroundColor: 'transparent',
  '&:hover': {
    borderColor: BUTTON_BORDER_COLOR,
    backgroundColor: 'transparent'
  },
  '&.Mui-focusVisible, &:focus-visible': {
    borderColor: theme.palette.primary.main
  }
})

const getFilterBarCss = (theme: Theme) => ({
  '& .MuiFormControl-root': {
    m: 1
  },
  '& .MuiFilledInput-adornedEnd': {
    paddingTop: '12px!important'
  },
  '& .MuiFilledInput-root': {
    border: 1,
    borderColor: theme.palette.divider,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.divider
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.primary.main
    }
  },
  '& .MuiFilledInput-input': {
    color: theme.palette.text.primary,
    padding: '20px 12px 10px'
  },
  '& .MuiFormLabel-root': {
    fontSize: '14px'
  },
  '& .MuiSelect-icon': {
    color: theme.palette.text.primary
  },
  '& .MuiInputLabel-filled': {
    color: theme.palette.text.secondary
  }
})

export const filterSxStyles: Record<string, SxProps<Theme>> = {
  filterBar: (theme) => ({...getFilterBarCss(theme)}),
  filterLayover: (theme) => ({...getFilterBarCss(theme), marginTop: theme.spacing(-4)}),
  filterButton: {
    display: 'inline-block',
    float: 'right'
  },
  filterSearchButton: (theme) => ({...getButtonOutlineWhite(theme), m: 1}),
  dateFilter: (theme) => ({
    margin: 1,
    '& .MuiButtonBase-root': {
      padding: '2px 10px',
      background: 'transparent',
      border: 1,
      borderColor:
        theme.palette.mode === 'light' ? BUTTON_BORDER_COLOR : theme.palette.divider,
      '&:hover': {
        borderColor:
          theme.palette.mode === 'light' ? BUTTON_BORDER_COLOR : theme.palette.divider
      },
      '&.Mui-focusVisible, &:focus-visible': {
        borderColor: theme.palette.primary.main
      }
    },
    '& .MuiTypography-root': {
      color: theme.palette.text.primary
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.primary
    },
    '& .MuiTypography-caption': {
      color: theme.palette.text.secondary
    }
  }),
  textInputField: (theme) => ({
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    width: {
      md: 200
    },
    '& .MuiOutlinedInput-root': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent'
    },
    '& fieldset': {
      borderColor: theme.palette.divider
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider
    },
    '& .Mui-focused.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.text.primary
    }
  })
}
